module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advisor_tiktok_desktop_10@2x-efe4a651e8b34a257a2526b34b3b279a.jpg";